/* eslint-disable no-return-assign */
import Backbone from "backbone";
import Marionette from "backbone.marionette";
import slider from "nouislider";
import qs from "query-string";
import _ from "lodash";
import $ from "jquery";

import { ROLE_TYPE_STRING } from "lib/constants";

import CommuteAddress from "./commuteAddress";
import templ from "../templates/components";
import config from "../config";
import modelUtil from "../models/util";

function formatWage(value) {
    const parts = Number(value).toFixed(2).toString().split(".");
    const dollars = parts[0];
    let cents = parts.length === 1 ? "" : parts[1].substr(0, 2);
    if (cents) {
        cents = _.padEnd(cents, 2, "0");
        if (cents === "00") {
            cents = "";
        } else {
            cents = `.${cents}`;
        }
    }
    return `$${dollars}${cents}/hr`;
}

const DEFAULT_FILTERS = {
    commute_type: 0,
    commute_length: null,
    role: 0,
    shift: 0,
    background: null,
    screen: null,
    weekend: null,
    entry: null,
    wage_start: null,
    wage_end: null,
};

const CommuteModal = Marionette.View.extend({
    template: false,
    ui: {
        address: ".js-commute-address",
        addressInput: ".js-commute-address-input",
        commuteAddressSaveLink: ".js-save-address",
        commuteTypes: "[name=commute_type]",
    },
    events: {
        "click @ui.commuteAddressSaveLink": "onSaveAddress",
        "click .js-cancel": "onCancel",
    },
    render() {
        this.$el.modal({
            closeClass: "icon-close",
            closeText: "&times;",
            escapeClose: false,
            fadeDuration: 350,
            fadeDelay: 0,
        });

        this.address = new CommuteAddress({
            el: this.ui.address,
            addressEl: this.ui.addressInput,
            saveLink: this.ui.commuteAddressSaveLink,
        });
        this.listenTo(this.address, "finish", (data) => {
            $.modal.close();

            this.trigger("commute", {
                ...data,
                types: this.types,
            });
        });
        this.address.render();
    },
    onCancel() {
        $.modal.close();
    },
    onSaveAddress(event) {
        event.preventDefault();

        this.types = this.ui.commuteTypes
            .filter(":checked")
            .map((idx, el) => Number($(el).val()))
            .toArray();

        this.address.saveAddress();
    },
});

const FiltersComponent = Marionette.View.extend({
    template: templ.Filters,
    ui: {
        role: ".role",
        option: ".filter-option",
        select: ".filter-select",
        prefsBtn: ".js-filter-prefs",
        roleBtn: "#btn-role",
        roleLabel: "#btn-role .filter-label",
        roleOption: ".role-option",
        shiftOption: ".shift-option",
        shiftBtn: "#btn-shift",
        shiftLabel: "#btn-shift .filter-label",
        moreBtn: "#btn-more",
        moreCount: "#btn-more .count",
        commuteBtn: "#btn-commute",
        commuteLabel: "#btn-commute .filter-label",
        commuteType: "[name=commute_type]",
    },
    events: {
        "click @ui.roleBtn": "showRoleModal",
        "click @ui.shiftBtn": "showShiftModal",
        "click @ui.moreBtn": "showMoreModal",
        "click @ui.commuteBtn": "showCommuteModal",
        "click @ui.prefsBtn": "onFilterByPrefs",
    },
    initialize() {
        this.preferences = _.clone(window.preferences) || {};
        this.preFiltered = !!window.preFiltered;
        this.commute = _.clone(window.commute) || null;
        this.commuteType = modelUtil.COMMUTE_TYPE.DRIVING;
        this.filtersUpdated = false;

        const filterChannel = Backbone.Radio.channel("filters");
        filterChannel.on("preferences", (data) => {
            this.preferences = data;
            this.filterByPrefs();
        });

        if (this.preFiltered) {
            this.setFiltersFromPrefs();
        } else {
            this.parseFilters();

            const preFiltered = Object.keys(this.filters).filter((k) => !!this.filters[k]);

            if (preFiltered.length > 0) {
                this.preFiltered = true;
            }
        }
    },
    bindFilterOption($modal) {
        const $option = $modal.find(".filter-option");
        $option.off().click((e) => {
            this.toggleOption($(e.target));
        });

        const $select = $modal.find(".filter-select");
        $select.off().on("change", (e) => {
            this.toggleSelect($(e.target));
        });

        $modal.off($.modal.CLOSE).on($.modal.CLOSE, () => {
            if (this.filtersUpdated) {
                // They updated filters away from whatever their prefs were
                if (this.ui.prefsBtn.hasClass("filtered")) {
                    this.ui.prefsBtn.removeClass("filtered");
                }

                this.filtersUpdated = false;
                this.updateQuery();
            }
        });
    },
    showCommuteModal() {
        this.commuteModal.render();
        this.bindFilterOption(this.commuteModal.$el);
    },
    showRoleModal() {
        const $modal = $("#role-modal");
        $modal.modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
        this.bindFilterOption($modal);
    },
    showShiftModal() {
        const $modal = $("#shift-modal");
        $modal.modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
        this.bindFilterOption($modal);
    },
    showMoreModal() {
        const $modal = $("#more-modal");
        $modal.modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
        this.bindFilterOption($modal);

        const values = [
            this.filters.wage_start || config.WAGE_MIN,
            this.filters.wage_end || config.WAGE_MAX,
        ];

        if (this.wage) {
            this.wage.set(values);
        } else {
            // See https://refreshless.com/nouislider/slider-options/
            this.wage = slider.create($modal.find(".wage-range")[0], {
                start: values,
                connect: true,
                margin: 1,
                // limit: 0,
                step: 1,
                range: {
                    min: config.WAGE_MIN,
                    max: config.WAGE_MAX,
                },
                tooltips: [
                    { from: formatWage, to: formatWage },
                    { from: formatWage, to: formatWage },
                ],
            });

            // Force the left handle to a max value of 25
            const LEFT_MAX = 25;
            this.wage.on("update", (wage) => {
                const left = Math.floor(wage[0]);
                if (left > LEFT_MAX) {
                    this.wage.set([LEFT_MAX, wage[1]]);
                }
            });

            this.wage.on("change", () => {
                const wage = this.wage.get();
                const start = Number(wage[0]).toFixed(2);
                const end = Number(wage[1]).toFixed(2);

                this.filters.wage_start = start === config.WAGE_MIN.toFixed(2) ? null : start;
                this.filters.wage_end = end === config.WAGE_MAX.toFixed(2) ? null : end;

                this.filtersUpdated = true;
            });
        }
    },
    parseFilters() {
        const query = qs.parse(window.location.search);

        this.filters = {
            commute_type: query.commute_type || 0,
            commute_length: query.commute_length || null,
            role: query.role || 0,
            shift: query.shift || 0,
            background: query.background == "false" ? "false" : null,
            screen: query.screen == "false" ? "false" : null,
            weekend: query.weekend == "false" ? "false" : null,
            entry: query.entry == "true" || null,
            wage_start: query.wage_start || null,
            wage_end: query.wage_end || null,
        };
    },
    setFiltersFromPrefs() {
        const preferred = [modelUtil.SHIFT_PREFERENCE.OKAY, modelUtil.SHIFT_PREFERENCE.PREFERRED];

        this.filters = _.defaults(this.preferences, DEFAULT_FILTERS);
        this.filters.weekend =
            preferred.indexOf(this.preferences.shift_weekend) > -1 ? null : "false";
        this.filters.wage_start = this.filters.wage;

        const shifts = [
            [this.preferences.shift_day, modelUtil.START_TIME.DAY],
            [this.preferences.shift_swing, modelUtil.START_TIME.SWING],
            [this.preferences.shift_night, modelUtil.START_TIME.NIGHT],
        ];

        shifts.forEach((shift) => {
            if (preferred.indexOf(shift[0]) > -1) {
                this.filters.shift |= shift[1];
            }
        });

        delete this.filters.search_status;
        delete this.filters.wage;
    },
    updateUI() {
        _.each(this.ui.roleOption, (el) => {
            $(el).prop("checked", this.filters.role & $(el).val());
        });

        const roleTypes = Object.keys(ROLE_TYPE_STRING).reduce(
            (memo, roleType) =>
                this.filters.role & roleType ? memo.concat([ROLE_TYPE_STRING[roleType]]) : memo,
            [],
        );
        const roleTypeCount = roleTypes.length;
        if (roleTypeCount === 1) {
            this.ui.roleLabel.text(roleTypes[0]).parent().addClass("filtered");
        } else if (roleTypeCount > 1) {
            const text =
                roleTypeCount === Object.keys(ROLE_TYPE_STRING).length
                    ? "All categories"
                    : `${roleTypeCount} categories`;

            this.ui.roleLabel.text(text).parent().addClass("filtered");
        } else {
            this.ui.roleLabel.text("Category").parent().removeClass("filtered");
        }

        _.each(this.ui.shiftOption, (el) => {
            $(el).prop("checked", this.filters.shift & $(el).val());
        });

        this.ui.option.filter("[name=weekend]").prop("checked", !!this.filters.weekend);
        this.ui.option.filter("[name=background]").prop("checked", !!this.filters.background);
        this.ui.option.filter("[name=screen]").prop("checked", !!this.filters.screen);
        this.ui.option.filter("[name=entry]").prop("checked", !!this.filters.entry);

        _.each(this.ui.commuteType, (el) => {
            $(el).prop("checked", this.filters.commute_type & $(el).val());
        });

        if (this.filters.commute_length) {
            this.ui.select.filter("[name=commute_length]").val(this.filters.commute_length);
        }

        const moreCount = _.reduce(
            [
                this.filters.background,
                this.filters.screen,
                this.filters.entry,
                (this.filters.wage_start &&
                    Number(this.filters.wage_start).toFixed(2) !== config.WAGE_MIN.toFixed(2)) ||
                    this.filters.wage_end,
            ],
            (sum, x) => sum + (x ? 1 : 0),
            0,
        );

        if (moreCount > 0) {
            this.ui.moreCount.text(moreCount);
            this.ui.moreCount.show();
        } else {
            this.ui.moreCount.hide();
        }

        if (!this.filters.weekend && !this.filters.shift) {
            this.ui.shiftLabel.text("Shift").parent().removeClass("filtered");
        } else {
            let shiftLabel = [];
            const shift = Number(this.filters.shift);
            if (shift === modelUtil.ALL_SHIFTS) {
                shiftLabel.push("Any shift");
            } else {
                if (shift & modelUtil.START_TIME.DAY) {
                    shiftLabel.push("Day");
                }
                if (shift & modelUtil.START_TIME.SWING) {
                    shiftLabel.push("Swing");
                }
                if (shift & modelUtil.START_TIME.NIGHT) {
                    shiftLabel.push("Night");
                }

                if (shiftLabel.length > 1) {
                    shiftLabel = [`${shiftLabel.length} shifts`];
                }
            }

            if (this.filters.weekend) {
                shiftLabel.push("No weekends");
            }

            this.ui.shiftLabel.text(shiftLabel.join(", ")).parent().addClass("filtered");
        }

        if (!this.filters.commute_length) {
            this.ui.commuteLabel.text("Commute").parent().removeClass("filtered");
        } else {
            this.ui.commuteLabel
                .text(`<${this.filters.commute_length} min`)
                .parent()
                .addClass("filtered");
        }
    },
    toggleOption($el) {
        const name = $el.attr("name");
        const options = $(`input[name=${name}].filter-option:checked`);
        this.filters[name] = _.reduce(
            options,
            (value, el) => (value ? (value |= $(el).val()) : $(el).val()),
            undefined,
        );

        this.filtersUpdated = true;
    },
    toggleSelect($el) {
        const name = $el.attr("name");

        this.filters[name] = $el.val();

        this.filtersUpdated = true;
    },
    updateQuery() {
        const query = qs.parse(window.location.search);
        _.extend(query, this.filters);

        Object.keys(this.filters).forEach((name) => {
            if (!this.filters[name]) {
                delete query[name];
            }
        });

        if (query.preferences) {
            delete query.preferences;
        }

        const newPath = `${window.location.pathname}?${qs.stringify(query)}`;

        // Don't push weird query state onto JD pages because they'll get dumb
        if (window.location.pathname.indexOf("/featured/") === -1) {
            window.history.pushState({}, "", newPath);
        }

        this.parseFilters();
        this.updateUI();

        const $container = $("#positions-list");
        $container.html('<div class="list-bouncer bouncer"></div>');

        const extra = {
            ajax: true,
        };

        if (this.commute && this.commute.geohash) {
            extra.geohash = this.commute.geohash;
        }

        $.ajax({
            type: "GET",
            url: `${newPath}&${qs.stringify(extra)}`,
            dataType: "html",
            success: (content) => {
                $container.html(content);
                // dear justin: this is stupid plz make better
                this.options.attachHandlers();

                if (this.filters.commute_type) {
                    const type = Number(this.filters.commute_type);
                    const $driving = $(".position-driving-time");
                    const $transit = $(".position-transit-time");

                    // Kinda gross, but force the visible commute type to be accurate if
                    // they only selected one of the types in the filter
                    if (type === modelUtil.COMMUTE_TYPE.DRIVING) {
                        $driving.show();
                        $transit.hide();
                    } else if (type === modelUtil.COMMUTE_TYPE.TRANSIT) {
                        $driving.hide();
                        $transit.show();
                    } else {
                        $driving.show();
                        $transit.show();
                    }
                }
            },
        });
    },
    onRender() {
        this.bindUIElements();
        this.updateUI();

        this.commuteModal = new CommuteModal({
            el: $("#commute-modal"),
        });
        this.listenTo(this.commuteModal, "commute", this.onCommuteData);
    },
    onCommuteData(commute) {
        this.commute = commute;
        this.filters.commute_type = commute.type;
        this.updateQuery();
    },
    onFilterByPrefs(event) {
        event.preventDefault();

        const $target = $(event.currentTarget);
        $target.toggleClass("filtered");

        if ($target.hasClass("filtered")) {
            this.filterByPrefs();
        } else {
            this.clear();
        }

        $target.blur();
    },
    filterByPrefs() {
        this.setFiltersFromPrefs();
        this.updateQuery();
    },
    serializeData() {
        return {
            commuteType:
                this.commuteType === modelUtil.COMMUTE_TYPE.DRIVING ? "Driving" : "Transit",
            hasCommute: window.commute && window.commute.geohash,
            hasPrefs: !!window.preferences,
            preFiltered: this.preFiltered,
            hideRoles: this.options.hideRoles,
            ROLE_TYPES: ROLE_TYPE_STRING,
        };
    },
    clear() {
        this.filters = _.clone(DEFAULT_FILTERS);
        this.updateQuery();
    },
});

export default {
    CommuteModal,
    Component: FiltersComponent,
};
